import React from "react";

import BannerCard from "./BannerCard";
import CategoryItem from "./categoryItem";

const HomeV2 = ({
  featuredAssetList,
  callAssetDetailPage,
  onHandleClick,
  entities,
}) => {
  return (
    <div className="home-content mx-8">
      <BannerCard />

      <div className="">
        <div className="d-flex justify-content-between feature-box">
          <h3>Featured</h3>
          <h3 className="view-all">View All</h3>
        </div>

        <CategoryItem
          renderData={featuredAssetList}
          onClick={(item) => callAssetDetailPage(item)}
        />
      </div>

      <div>
        <div className="d-flex justify-content-between feature-box">
          <h3>Recently Listed</h3>
          <h3 className="view-all">View All</h3>
        </div>
        <CategoryItem
          renderData={entities}
          onClick={(item) => onHandleClick(item)}
        />
      </div>
    </div>
  );
};

export default HomeV2;
